module.exports = __webpack_public_path__ + "img/logo_republica_del_ecuador.9cd98cff.png";